import { ITheme } from "../reducers/ThemeReducer";
import { SET_THEME } from "./actionTypes";

export const setTheme = (value: ITheme) => ({
    type: SET_THEME,
    payload: value,
});
